/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryResource extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryResource");
    }

    getFixupPrototypeFunction() { return ResourceQueryResource.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryResource>): ResourceQueryResource {
        let obj = Object.assign(new ResourceQueryResource(), model);
        ResourceQueryResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryResource>): ResourceQueryResource {
        if (!model) return null;
        return ResourceQueryResource.newInstance(<ResourceQueryResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryResource) {
        if (!obj) return;

        models.ResourceQueryResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryResource): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource fields for the resources
     */
    resources: Array<string>;

}
